import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// Bridge component for CONEK-4562 field-sales map. On connect, asks the native
// shell to request the ACCESS_FINE_LOCATION / ACCESS_COARSE_LOCATION runtime
// permission (API 23+) up-front, so the AWS Location MapLibre map can center on
// / show the rep's own position without a first-use permission stall.
//
// Mounted on the mobile layout only when `mobile.rep.geo` is on for the tenant,
// signalled via `<meta name="mobile-rep-geo" content="true">` (mirrors the same
// meta-tag-gating convention used for push — see app/views/layouts/mobile.html.erb).
// Graceful degradation: if the meta tag is absent, or no bridge is present
// (plain mobile browser, not the Turbo Native shell), every method is a no-op —
// the map still works, it just fits bounds over the route stops instead of
// centering on the device.
export default class extends BridgeComponent {
  static component = "location-permission"

  connect() {
    if (!this.enabled()) return

    super.connect()
    this.send("request_permission", {}, (message) => {
      this.handleReply(message)
    })
  }

  enabled() {
    return (
      document.querySelector('meta[name="mobile-rep-geo"]')?.content === "true"
    )
  }

  handleReply(message) {
    if (!message) return
    // The bridge callback receives the full message envelope {id, component, event, data: {...}}.
    // Extract the payload; fall back to the raw argument for direct callers (tests, etc.).
    const data =
      message.data !== null &&
      message.data !== undefined &&
      typeof message.data === "object"
        ? message.data
        : message
    if (!data) return

    // Broadcast the outcome so the map controller (or any listener) can enable a
    // "center on me" affordance once the OS permission is held. When denied, the
    // map simply never offers it — no error surface, matching the push bridge's
    // silent graceful-degradation style.
    this.dispatch("resolved", {
      detail: { granted: Boolean(data.granted) },
      prefix: "location-permission",
    })
  }
}
